import { render, staticRenderFns } from "./DetailCourseGroup.vue?vue&type=template&id=5c74390d&scoped=true"
import script from "./DetailCourseGroup.vue?vue&type=script&lang=js"
export * from "./DetailCourseGroup.vue?vue&type=script&lang=js"
import style0 from "./DetailCourseGroup.vue?vue&type=style&index=0&id=5c74390d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c74390d",
  null
  
)

export default component.exports